<template>
  <div id="game-base">
    <game-instructions v-if="screen === 'instructions'" @close="goToGame"/>
    <flip-cards-game v-if="screen === 'game'" @game-over="endGame"/>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated zoomInUp faster"
      leave-active-class="animated zoomOutDown">
      <end-game v-if="screen=== 'endGame'" :time="finalTime" :score="score"/>
    </transition>
  </div>
</template>

<script>
import FlipCardsGame from './components/flip-cards-game.vue'
import GameInstructions from './components/game-instructions.vue'
import EndGame from './components/end-game.vue'

export default {
  name: 'GameBase',
  components: {
    FlipCardsGame,
    GameInstructions,
    EndGame
  },
  data () {
    return {
      screen: 'instructions', // instructions, game, endGame
      score: 0,
      finalTime: '',
      finalTimeMilliseconds: 0
    }
  },
  methods: {
    goToGame () {
      this.screen = 'game'
    },
    endGame ({ score, time, timeMilliseconds }) {
      this.$emit('finish-game', { time: timeMilliseconds, score: score })
      this.score = score
      this.finalTime = time
      this.finalTimeMilliseconds = timeMilliseconds
      this.screen = 'endGame'
    }
  }
}
</script>

<style lang="scss">
  @import "assets/styles/global";
  #game-base{
    background: linear-gradient(#0088FF, #004785);
    height: 100%;
    width: 100vw;
    position: fixed;
  }
</style>
